import { render, staticRenderFns } from "./UpgradeQueue.vue?vue&type=template&id=0489d324&scoped=true"
import script from "./UpgradeQueue.vue?vue&type=script&lang=js"
export * from "./UpgradeQueue.vue?vue&type=script&lang=js"
import style0 from "./UpgradeQueue.vue?vue&type=style&index=0&id=0489d324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489d324",
  null
  
)

export default component.exports